<template>
  <div>
    <p class="titleModal">
      {{ $t(`technicalFile.cooling.step4.title2`) }}
    </p>
    <v-row>
      <v-col class="blocBTNFile">
        <UploadedBackendFiles
          :backendFiles="getFiles"
          :readonly="readonly"
          @removeFiles="removeFile"
        />
      </v-col>
    </v-row>
    <div
      v-for="(file, index) in data.newFiles"
      :key="index"
    >
      <v-row
        class="file-container"
        align="center"
        justify="center"
      >
        <v-col
          cols="12"
          class="noYPadding bloc-btn"
        >
          <div style="width: 95%">
            <VFile
              v-model="data.newFiles[index]"
              outlined
              :label="$t('forms.labels.file')"
              :isEdition="isEditable"
              :readonly="readonly"
              :rules="{
                mimes: acceptedFormats,
                size: 10000000
              }"
              cyData="otherInformationFile"
              prependIcon=""
              @input="updateData(true)"
            />
          </div>
          <div style="width: 3%">
            <v-btn
              v-if="index === 0"
              icon
              class="ml-3 add-btn"
              color="white"
              small
              @click="addEmptyFile"
            >
              <v-icon>
                mdi-plus
              </v-icon>
            </v-btn>
          </div>
        </v-col>
        <v-col
          cols="1"
          class="noYPadding bloc-btn"
        />
      </v-row>
    </div>
    <p class="titleModal">
      {{ $t(`technicalFile.cooling.step4.notes`) }}
    </p>
    <v-row>
      <v-col class="noYPadding">
        <VTextarea
          v-model="data.note"
          class="text-field-transparent"
          :rules="{ max: 300 }"
          outlined
          :readonly="readonly"
          flat
          data-cy="otherInformationNote"
          @input="updateData"
        />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import VFile from '@/components/shared/widgets/forms/VuetifyInputs/VFile';
import VTextarea from '@/components/shared/widgets/forms/VuetifyInputs/VTextarea.vue';
import { cloneDeep } from 'lodash';
import UploadedBackendFiles from '@/components/shared/UploadedBackendFiles.vue';

export default {
    name: 'OtherInformation',
    components: {
        VFile,
        VTextarea,
        UploadedBackendFiles,
    },
    props: {
        otherInformation: {
            type: Object,
            default: () => {},
        },
        parentNode: {
            type: String,
            default: () => '',
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            data: {},
            isEditable: false,
            acceptedFormats: [
                'image/jpeg',
                'image/gif',
                'image/png',
                'application/pdf',
            ],
        };
    },
    computed: {
        getFiles() {
            // eslint-disable-next-line no-underscore-dangle
            return this.data.files.map(file => ({ ...file, id: file._id }));
        },
    },
    watch: {
        otherInformation: {
            handler() {
                this.data = { ...this.data, newFiles: [null], ...cloneDeep(this.otherInformation) };
            },
            immediate: true,
        },
    },
    methods: {
        updateData(isFile) {
            if (isFile) this.isEditable = true;
            this.$emit('sendData', { otherInformation: this.data });
        },
        addEmptyFile() {
            this.data.newFiles.unshift(null);
        },
        async downloadFile(image) {
            const { data } = await this.$rq.downloadFile(image.id);
            this.$utils.saveFileOnDisk(data, image.link.fileName);
        },
        async removeFile(imageId) {
            await this.$rq.deleteFile(imageId);
            // eslint-disable-next-line no-param-reassign
            this.data.files = this.data.files.filter(file => {
                // eslint-disable-next-line no-underscore-dangle
                const id = file.id || file._id;
                return id !== imageId;
            });
            this.$emit('sendData', { otherInformation: this.data });
        },
    },
};
</script>
<style lang="scss" scoped>
 .file-container {
    display: flex;
    padding: 0;
 }

.image a {
    text-decoration: underline;
}
.noYPadding {
    padding-bottom: 0;
    padding-top: 0;
}
.add-btn{
  margin-top: -30px;
  border: 1px solid #ef4135;
  background-color: #ef4135;
}
.bloc-btn {
  width:100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.blocBTNFile {
  margin-left: 12px
}
</style>
